import ReactDOM from 'react-dom/client';
import {
    createBrowserRouter,
    Navigate,
    RouterProvider,
} from 'react-router-dom';
import App from './App';
import './index.css';
import OrderPage from './components/Pages/Order/Page';
import MainPage from './components/Pages/Main/Page';
import LegalPage from './components/Pages/Legal/Page';
import { Provider } from 'react-redux';
import store from './store/store';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        children: [
            {
                index: true,
                element: <MainPage />,
            },
            {
                path: 'order',
                element: <OrderPage />,
            },
            {
                path: 'legal',
                element: <LegalPage />,
            },
            {
                path: '*',
                element: <Navigate to="/" replace={true} />,
            },
        ],
    },
]);

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement,
);
root.render(
    <QueryClientProvider client={queryClient}>
        <Provider store={store}>
            <RouterProvider router={router} />
        </Provider>
    </QueryClientProvider>,
);
